import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {HomeComponent} from './home/home.component';
import { AuthGuard } from './_helpers/auth.guard';
import { AdminGuard } from './_helpers/admin.guard';
import {ServerdownComponent} from './serverdown/serverdown.component';
import {LookupComponent} from './lookup/lookup.component';
import {AbsenceComponent} from './absence/absence.component';
import { EmployeeListComponent } from './employee/employee-list/employee-list.component';
import {RoleselectComponent} from './roleselect/roleselect.component';
import { PortaluserListComponent } from './portaluser/portaluser-list/portaluser-list.component';
import {RequestsComponent} from './requests/requests.component';
import { GeneraldocumentListComponent } from './generaldocument/generaldocument-list/generaldocument-list.component';
import {ForgetpasswordComponent} from './forgetpassword/forgetpassword.component';
import {PasswordUpdateComponent} from './password-update/password-update.component';
import {ProfileComponent} from './profile/profile.component';
import { OvertimeComponent } from './overtime/overtime.component';
import { ProcurementComponent } from './procurement/procurement.component';
import { ItemAuthorizationsComponent } from './item-authorizations/item-authorizations.component';
import { TransferComponent } from './transfer/transfer.component';


const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'forgetpassword', component: ForgetpasswordComponent },
  { path: 'password/update/:token', component: PasswordUpdateComponent },
  { path: 'roleselect', component: RoleselectComponent },
  { path: 'lookup', component: LookupComponent, canActivate: [AuthGuard] },
  { path: 'absence', component: AbsenceComponent, canActivate: [AuthGuard] },
  { path: 'overtime', component: OvertimeComponent, canActivate: [AuthGuard] },
  { path: 'employee1', component: EmployeeListComponent, canActivate: [AuthGuard] },
  { path: 'portaluser', component: PortaluserListComponent, canActivate: [AuthGuard] },
  { path: 'request', component: RequestsComponent, canActivate: [AuthGuard] },
  { path: 'generaldocument', component: GeneraldocumentListComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'procurement', component: ProcurementComponent, canActivate: [AuthGuard] },
  { path: 'item-authorizations', component: ItemAuthorizationsComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'transfer', component: TransferComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'unknownerror', component: ServerdownComponent},


  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
